export const ChunkArray = (arr, size) => {
  if (arr?.length === 0) return null;
  else
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
};
